<template>
  <div class="user">
    <!--内容-->
    <div class="ml10 d-s-c">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-button-group>
            <!-- <el-button @click="changeTypeFunc('')">不限</el-button> -->
            <el-button :type="formInline.type == 10 ? 'primary' : ''" plain @click="changeTypeFunc(10)">刷题</el-button>
            <el-button :type="formInline.type == 71 ? 'primary' : ''" plain @click="changeTypeFunc(71)">真题训练</el-button>
            <!-- <el-button :type="formInline.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button> -->
          </el-button-group>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="question_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="type" label="类型" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.type == 71 ? '真题训练' : '刷题'}}
            </template>
          </el-table-column>
          <el-table-column prop="question.question" label="答题">
            <template slot-scope="scope">
              <p v-html="scope.row.question.question" v-if="scope.row.question.question"></p>
            </template>
          </el-table-column>
          <el-table-column prop="user_count" label="错题人数" align="center"></el-table-column>
          <el-table-column prop="error_rate" label="错误率(%)" align="center"></el-table-column>
          <el-table-column prop="question.answer_type" label="答案类型" width="100" align="center">
            <template slot-scope="scope">
              {{ answer_type[scope.row.question.answer_type].name }}
            </template>
          </el-table-column>
          <el-table-column prop="content" label="关联答题" width="130" align="center">
            <template slot-scope="scope">
              <el-button size="mini" href="/" target="_blank" @click="onDetail(scope.row)">查看答题</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" width="130" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-if="scope.row.path!='/plus'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
  import QuestionErrorApi from '@/api/study/question_error.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        formInline: {
          type: 10,
        },
        /*列表数据*/
        tableData: [],
        answer_type: {},
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*选择类型*/
      changeTypeFunc(e){
        this.formInline.type = e;
        this.getTableList();
      },
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {question_id: row.question_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        QuestionErrorApi.show(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list;
          self.answer_type = data.answer_type;
        }).catch(error => {
          self.loading = false;
        });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            QuestionErrorApi.del({question_id: row.question_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/questionerrorranking/part/Show.vue